<template>
  <div class="device-template-container">
    <el-card shadow="never">
      <div class="card-header">
        <h2>设备模板</h2>
        <el-button type="primary" @click="dialogVisible = true">
          <i class="el-icon-plus"></i> 新增设备模板
        </el-button>
      </div>
      
      <el-table :data="deviceTemplates" stripe style="width: 100%" v-loading="loading">
        <el-table-column type="index" label="序号" width="80" :index="indexMethod"></el-table-column>
        <el-table-column prop="name" label="模板名称" width="200"></el-table-column>
        <el-table-column prop="description" label="描述"></el-table-column>
        <el-table-column prop="variables" label="变量数量" width="120">
          <template slot-scope="scope">
            {{ scope.row.variables ? scope.row.variables.length : 0 }}
          </template>
        </el-table-column>
        <el-table-column prop="enabled" label="状态" width="120">
          <template slot-scope="scope">
            <el-switch 
              v-model="scope.row.enabled" 
              active-color="#13ce66" 
              inactive-color="#ff4949"
              @change="handleStatusChange(scope.row)"
            ></el-switch>
          </template>
        </el-table-column>
        <el-table-column prop="createTime" label="创建时间" width="200">
          <template slot-scope="scope">
            {{ formatDate(scope.row.createTime) }}
          </template>
        </el-table-column>
        <el-table-column prop="updateTime" label="更新时间" width="200">
          <template slot-scope="scope">
            {{ formatDate(scope.row.updateTime) }}
          </template>
        </el-table-column>
        <el-table-column label="操作" width="250" fixed="right">
          <template slot-scope="scope">
            <el-button type="primary" size="small" @click="editVariables(scope.row)">
              管理变量
            </el-button>
            <el-button type="info" size="small" @click="editDeviceTemplate(scope.row)">
              编辑模板
            </el-button>
            <el-button type="danger" size="small" @click="deleteDeviceTemplate(scope.row.id)">
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      
      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total">
        </el-pagination>
      </div>
    </el-card>
    
    <!-- 新增/编辑设备模板对话框 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="600px"
    >
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="模板名称" prop="name">
          <el-input v-model="form.name" placeholder="请输入设备模板名称"></el-input>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input
            v-model="form.description"
            type="textarea"
            :rows="3"
            placeholder="请输入设备模板描述"
          ></el-input>
        </el-form-item>
        <el-form-item label="状态">
          <el-switch v-model="form.enabled" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </span>
    </el-dialog>
    
    <!-- 变量管理抽屉 -->
    <el-drawer
      :title="'管理模板变量 - ' + currentTemplate.name"
      :visible.sync="variableDialogVisible"
      :size="1200"
      direction="rtl"
      append-to-body
      custom-class="variable-drawer"
    >
      <div class="variable-management">
        <div class="variable-header">
          <h3>变量列表</h3>
          <el-button type="primary" size="small" @click="addVariable">
            <i class="el-icon-plus"></i> 添加变量
          </el-button>
        </div>
        
        <el-table :data="currentTemplate.variables" border style="margin-bottom: 20px;">
          <el-table-column prop="variableId" label="变量ID" width="150"></el-table-column>
          <el-table-column prop="variableName" label="变量名称" width="150"></el-table-column>
          <el-table-column prop="variableType" label="变量类型" width="120">
            <template slot-scope="scope">
              <el-tag size="small" type="primary">{{ scope.row.variableType }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="dataType" label="数据类型" width="120"></el-table-column>
          <el-table-column prop="accessMode" label="读写权限" width="100">
            <template slot-scope="scope">
              <el-tag size="small" :type="scope.row.accessMode === 'readwrite' ? 'success' : 'info'">
                {{ scope.row.accessMode === 'readwrite' ? '读写' : '只读' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="unit" label="单位" width="100"></el-table-column>
          <el-table-column prop="defaultValue" label="默认值" width="100"></el-table-column>
          <el-table-column prop="description" label="描述" width="200"></el-table-column>
          <el-table-column prop="enabled" label="状态" width="100">
            <template slot-scope="scope">
              <el-switch v-model="scope.row.enabled" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="150">
            <template slot-scope="scope">
              <el-button size="small" type="text" @click="editVariable(scope.row)">编辑</el-button>
              <el-button size="small" type="text" class="danger-text" @click="deleteVariable(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        
        <!-- 新增/编辑变量表单 -->
        <el-form v-if="variableFormVisible" :model="variableForm" :rules="variableRules" ref="variableForm" label-width="100px">
          <h4>{{ variableForm.id ? '编辑变量' : '新增变量' }}</h4>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="变量ID" prop="variableId">
                <el-input v-model="variableForm.variableId" placeholder="请输入变量ID"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="变量名称" prop="variableName">
                <el-input v-model="variableForm.variableName" placeholder="请输入变量名称"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="变量类型" prop="variableType">
                <el-select v-model="variableForm.variableType" style="width: 100%;">
                  <el-option label="属性" value="属性"></el-option>
                  <el-option label="事件" value="事件"></el-option>
                  <el-option label="命令" value="命令"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="数据类型" prop="dataType">
                <el-select v-model="variableForm.dataType" style="width: 100%;">
                  <el-option label="字符串" value="string"></el-option>
                  <el-option label="数字" value="number"></el-option>
                  <el-option label="布尔值" value="boolean"></el-option>
                  <el-option label="日期" value="date"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="读写权限">
                <el-select v-model="variableForm.accessMode" style="width: 100%;" :disabled="variableForm.variableType === '命令' || variableForm.variableType === '事件'">
                  <el-option label="只读" value="readonly"></el-option>
                  <el-option label="读写" value="readwrite"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="单位">
                <el-input v-model="variableForm.unit" placeholder="请输入单位"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="默认值">
                <el-input v-model="variableForm.defaultValue" placeholder="请输入默认值"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="状态">
                <el-switch v-model="variableForm.enabled" active-color="#13ce66" inactive-color="#ff4949"></el-switch>
              </el-form-item>
            </el-col>
          </el-row>
          <el-form-item label="描述">
            <el-input
              v-model="variableForm.description"
              type="textarea"
              :rows="2"
              placeholder="请输入变量描述"
            ></el-input>
          </el-form-item>
          <div style="text-align: right;">
            <el-button @click="cancelVariableForm">取消</el-button>
            <el-button type="primary" @click="submitVariableForm">确定</el-button>
          </div>
        </el-form>
      </div>
      <div slot="footer" class="drawer-footer">
        <el-button @click="variableDialogVisible = false">关闭</el-button>
        <el-button type="primary" @click="saveVariables">保存变量</el-button>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import api from '@/api'

export default {
  name: 'DeviceTemplate',
  data() {
    return {
      deviceTemplates: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增设备模板',
      form: {
        id: null,
        name: '',
        description: '',
        enabled: true
      },
      rules: {
        name: [
          { required: true, message: '请输入设备模板名称', trigger: 'blur' },
          { min: 2, max: 30, message: '长度在 2 到 30 个字符', trigger: 'blur' }
        ]
      },
      // 变量管理相关
      variableDialogVisible: false,
      currentTemplate: {},
      variableFormVisible: false,
      variableForm: {
        id: null,
        variableId: '',
        variableName: '',
        variableType: '属性',
        dataType: 'string',
        unit: '',
        defaultValue: '',
        description: '',
        enabled: true,
        accessMode: 'readonly'
      },
      variableRules: {
        variableId: [
          { required: true, message: '请输入变量ID', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        variableName: [
          { required: true, message: '请输入变量名称', trigger: 'blur' },
          { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
        ],
        variableType: [
          { required: true, message: '请选择变量类型', trigger: 'change' }
        ],
        dataType: [
          { required: true, message: '请选择数据类型', trigger: 'change' }
        ]
      }
    }
  },
  mounted() {
    console.log('组件已挂载，准备获取设备模板')
    this.getDeviceTemplates()
  },
  methods: {
    getDeviceTemplates() {
      this.loading = true
      console.log('开始获取设备模板，参数:', {
        page: this.currentPage,
        size: this.pageSize
      })
      api.getDeviceTemplates({
        page: this.currentPage,
        size: this.pageSize
      })
        .then(response => {
          console.log('获取设备模板成功，响应:', response)
          this.deviceTemplates = response.data || []
          this.total = response.total || this.deviceTemplates.length
          console.log('设置设备模板数据:', this.deviceTemplates)
          console.log('设置总数:', this.total)
        })
        .catch(error => {
          console.error('获取设备模板失败，错误:', error)
          this.$message.error('获取设备模板列表失败: ' + error.message)
        })
        .finally(() => {
          this.loading = false
        })
    },
    
    editDeviceTemplate(row) {
      this.dialogTitle = '编辑设备模板'
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogVisible = true
    },
    
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id) {
            // 更新设备模板
            api.updateDeviceTemplate(this.form.id, this.form)
              .then(() => {
                this.$message.success('设备模板更新成功')
                this.dialogVisible = false
                this.getDeviceTemplates()
              })
              .catch(error => {
                this.$message.error('设备模板更新失败')
                console.error('Error:', error)
              })
          } else {
            // 新增设备模板
            api.addDeviceTemplate(this.form)
              .then(() => {
                this.$message.success('设备模板新增成功')
                this.dialogVisible = false
                this.getDeviceTemplates()
              })
              .catch(error => {
                this.$message.error('设备模板新增失败')
                console.error('Error:', error)
              })
          }
        } else {
          return false
        }
      })
    },
    
    deleteDeviceTemplate(id) {
      this.$confirm('确定要删除该设备模板吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        api.deleteDeviceTemplate(id)
          .then(() => {
            this.$message.success('设备模板删除成功')
            this.getDeviceTemplates()
          })
          .catch(error => {
            this.$message.error('设备模板删除失败')
            console.error('Error:', error)
          })
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    handleStatusChange(row) {
      api.updateDeviceTemplate(row.id, row)
        .then(() => {
          this.$message.success('状态更新成功')
        })
        .catch(error => {
          this.$message.error('状态更新失败')
          console.error('Error:', error)
          // 恢复原来的状态
          row.enabled = !row.enabled
        })
    },
    
    handleSizeChange(val) {
      this.pageSize = val
      this.currentPage = 1
      this.getDeviceTemplates()
    },
    
    handleCurrentChange(val) {
      this.currentPage = val
      this.getDeviceTemplates()
    },
    
    indexMethod(index) {
      // 计算当前行在整个数据集中的序号
      return (this.currentPage - 1) * this.pageSize + index + 1
    },
    
    formatDate(dateString) {
      if (!dateString) return ''
      const date = new Date(dateString)
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()
      const hours = date.getHours()
      const minutes = date.getMinutes()
      const seconds = date.getSeconds()
      return `${year}-${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')} ${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`
    },
    
    // 变量管理相关方法
    editVariables(template) {
      this.currentTemplate = JSON.parse(JSON.stringify(template))
      // 初始化变量列表
      if (!this.currentTemplate.variables) {
        this.currentTemplate.variables = []
      }
      this.variableDialogVisible = true
      this.variableFormVisible = false
    },
    
    addVariable() {
      this.variableForm = {
        id: null,
        variableId: '',
        variableName: '',
        variableType: '属性',
        dataType: 'string',
        unit: '',
        defaultValue: '',
        description: '',
        enabled: true,
        accessMode: 'readonly'
      }
      this.variableFormVisible = true
    },
    
    editVariable(variable) {
      this.variableForm = JSON.parse(JSON.stringify(variable))
      this.variableFormVisible = true
    },
    
    deleteVariable(variable) {
      this.$confirm('确定要删除该变量吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        const index = this.currentTemplate.variables.findIndex(item => item.id === variable.id)
        if (index >= 0) {
          this.currentTemplate.variables.splice(index, 1)
          // 删除后立即保存到后端
          this.saveVariables()
          this.$message.success('变量删除成功')
        }
      }).catch(() => {
        this.$message.info('已取消删除')
      })
    },
    
    cancelVariableForm() {
      this.variableFormVisible = false
      this.variableForm = {
        id: null,
        variableId: '',
        variableName: '',
        variableType: '属性',
        dataType: 'string',
        unit: '',
        defaultValue: '',
        description: '',
        enabled: true,
        accessMode: 'readonly'
      }
    },
    
    submitVariableForm() {
      this.$refs.variableForm.validate((valid) => {
        if (valid) {
          if (this.variableForm.id) {
            // 更新变量
            const index = this.currentTemplate.variables.findIndex(item => item.id === this.variableForm.id)
            if (index >= 0) {
              this.currentTemplate.variables.splice(index, 1, this.variableForm)
              // 更新后立即保存到后端
              this.saveVariables()
              this.$message.success('变量更新成功')
            }
          } else {
            // 添加变量
            this.currentTemplate.variables.push(this.variableForm)
            // 添加后立即保存到后端
            this.saveVariables()
            this.$message.success('变量添加成功')
          }
          this.variableFormVisible = false
          this.variableForm = {
            id: null,
            variableId: '',
            variableName: '',
            variableType: '属性',
            dataType: 'string',
            unit: '',
            defaultValue: '',
            description: '',
            enabled: true
          }
        } else {
          return false
        }
      })
    },
    
    saveVariables() {
      api.updateDeviceTemplate(this.currentTemplate.id, this.currentTemplate)
        .then(() => {
          this.$message.success('变量保存成功')
          this.variableDialogVisible = false
          this.getDeviceTemplates()
        })
        .catch(error => {
          this.$message.error('变量保存失败')
          console.error('Error:', error)
        })
    }
  }
}
</script>

<style scoped>
.device-template-container {
  padding: 20px;
}

.card-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.card-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.pagination-container {
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
}

/* 变量管理抽屉样式 */
.variable-drawer {
  overflow: hidden;
}

/* 变量管理样式 */
.variable-management {
  height: calc(100vh - 200px);
  overflow-y: auto;
  padding: 0 10px;
}

.variable-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.variable-header h3 {
  margin: 0;
  font-size: 16px;
  font-weight: 600;
}

/* 抽屉页脚样式 */
.drawer-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
  border-top: 1px solid #ebeef5;
  background-color: #fff;
}

.drawer-footer .el-button {
  margin-left: 10px;
}

.danger-text {
  color: #F56C6C;
}
</style>